import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromAuth from './auth.reducer';
import * as fromStats from '../../statistics/store/reducers';
import * as fromManager from '../../managers/store/reducers';
import * as fromBrand from '../../brands/store/reducers';
import * as fromStores from '../../stores/store/reducers';
import * as fromPotential from '../../potentials/store/reducers';
import * as fromInvoice from '../../invoices/store/reducers';
import * as fromSmsBlast from './sms-blast.reducer';
import * as fromCandidate from '../../candidates/store/reducers';
import * as fromAvailabilities from '../../availabilities/store/reducers';
import * as fromFreelancers from '../../freelancers/store/reducers';
import * as fromShifts from '../../shifts/store/reducers';
import {InjectionToken} from '@angular/core';

export interface AppState {
  auth: fromAuth.AuthState;
  statsFeature: fromStats.StatisticsState;
  managersFeature: fromManager.ManagerState;
  brandsFeature: fromBrand.BrandsState;
  storesFeature: fromStores.StoresState;
  potentialsFeature: fromPotential.PotentialsState;
  invoicesFeature: fromInvoice.InvoicesState;
  smsBlast: fromSmsBlast.SmsBlastState;
  candidatesFeature: fromCandidate.CandidatesState;
  availabilitiesFeature: fromAvailabilities.AvailabilitiesState;
  freelancersFeature: fromFreelancers.FreelancersState;
  shiftsFeature: fromShifts.ShiftsState;
}

const reducers = {
  auth: fromAuth.reducer,
  statsFeature: fromStats.reducer,
  managersFeature: fromManager.reducer,
  brandsFeature: fromBrand.reducer,
  storesFeature: fromStores.reducer,
  potentialsFeature: fromPotential.reducer,
  invoicesFeature: fromInvoice.reducer,
  smsBlast: fromSmsBlast.reducer,
  candidatesFeature: fromCandidate.reducer,
  availabilitiesFeature: fromAvailabilities.reducer,
  freelancersFeature: fromFreelancers.reducer,
  shiftsFeature: fromShifts.reducer
};

export const reducerToken = new InjectionToken<ActionReducerMap<AppState>>('Reducer Registered');

export const reducerProvider = [{provide: reducerToken, useValue: reducers}];

export const getAppState = createFeatureSelector<AppState>('poured-hq');
export const getUserState = createSelector(getAppState, (state: AppState) => state.auth);

export const getFreelancerState = fromFreelancers.getFreelancerState;
export const getMessages = createSelector(fromFreelancers.getFreelancerState,
  (state: fromFreelancers.FreelancersState) => state.messages);
export const getFreelancers = createSelector(fromFreelancers.getFreelancerState,
  (state: fromFreelancers.FreelancersState) => state.freelancers);

export const getUsers = createSelector(getFreelancers, state => state.users);
export const getFreelancersError = createSelector(getFreelancers, state => state.error);
export const getFreelancer = createSelector(getFreelancers, state => state.user);


export const getManagerState = fromManager.getManagerState;
export const getManagers = createSelector(getManagerState, (state: fromManager.ManagerState) => state.managers);
export const getMUsers = createSelector(getManagers, state => state.users);
export const getManager = createSelector(getManagers, state => state.user);




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/store/reducers/index.ts